// Date/time formatting helpers.
//
// IMPORTANT: membership-api (and the ui-stock backend) serialize java.time
// LocalDateTime values as NAIVE timestamps with NO timezone marker, e.g.
// "2026-10-25T19:41:15.808" or "2026-10-25 19:41:15". Those values are actually
// UTC. If you pass such a string straight to `new Date(...)`, the browser parses
// it in the VIEWER'S LOCAL timezone, so it renders ~hours off and mislabeled
// (e.g. showing 7:41 PM when it is really 12:41 PM PT).
//
// These helpers detect a missing timezone and parse the value as UTC, then render
// in the viewer's local timezone WITH the zone abbreviation so it is unambiguous.
// Strings that already carry a Z or ±hh:mm offset are passed through untouched
// (never double-converted).

// Parse a server timestamp into a Date, treating naive (no-tz) strings as UTC.
export const parseServerDate = (d) => {
  if (!d) return null;
  // Date objects / epoch numbers pass through.
  if (d instanceof Date) return isNaN(d.getTime()) ? null : d;
  let s = String(d).trim();
  if (!s) return null;
  // Append 'Z' only when there is no timezone marker already.
  if (!/[zZ]|[+-]\d{2}:?\d{2}$/.test(s)) {
    s = s.replace(' ', 'T') + 'Z';
  }
  const dt = new Date(s);
  return isNaN(dt.getTime()) ? null : dt;
};

// Full date + time in the viewer's local timezone, with zone label.
// e.g. "10/25/2026, 12:41:15 PM PDT"
export const fmtDateTime = (d, fallback = '—') => {
  const dt = parseServerDate(d);
  if (!dt) return fallback;
  return dt.toLocaleString(undefined, { timeZoneName: 'short' });
};

// Date only (no time), local timezone. e.g. "10/25/2026"
export const fmtDate = (d, fallback = '—') => {
  const dt = parseServerDate(d);
  if (!dt) return fallback;
  return dt.toLocaleDateString();
};
